import { Cascader } from "ant-design-vue";
const { ...other } = Cascader;
const YwCascader = {
	...other,
	name: "YwCascader",
};
YwCascader.install = function (Vue) {
	Vue.component(YwCascader.name, Cascader);
};
export default YwCascader;
